<template>
  <div>
    <div class="questionnaire-header">
      <div class="col-10">
        <div class="questionnaire-header-title">Vidéo d'introduction</div>
      </div>
      <div class="col-2 questionnaire-header-logo"><img src="@/assets/img/logo.png"></div>
    </div>

    <div class="questionnaire-info">
      <p>Avant de commencer les tests, vous devez visionner cette vidéo d'introduction dans son intégralité.</p>
      <p>La pause est possible, mais vous ne pourrez pas avancer ou reculer dans la vidéo.</p>
    </div>

    <div class="questionnaire-section">
      <div class="questionnaire-section-header">
        <div class="questionnaire-section-header-main">Vidéo d'introduction</div>
      </div>

      <div class="questionnaire-section-action">
        <div class="questionnaire-section-action-button">
          <button :disabled="isDisabled" class="btn btn-primary btn-block" @click="emit('debuter', domainId)">
            <span>Commencer</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const domainId = 18;

defineProps({
  isDisabled: Boolean
});

const emit = defineEmits(['debuter']);

</script>
